export default {"src":"/_next/static/media/descriptionMecenat3.8429b1ad.svg","height":300,"width":400,"blurWidth":0,"blurHeight":0};